export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20atmosphere%20with%20deep%20crimson%20and%20charcoal%20gradient%2C%20subtle%20abstract%20geometric%20patterns%2C%20low%20key%20lighting%20with%20warm%20amber%20accents%2C%20cinematic%20moody%20backdrop%20with%20soft%20vignette%2C%20no%20text%20or%20people%2C%20sophisticated%20entertainment%20industry%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料在线背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex flex-wrap items-center gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/90 text-white rounded-full whitespace-nowrap">
                实时更新
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-white/15 text-white rounded-full whitespace-nowrap">
                高清正片
              </span>
              <span className="px-3 py-1 text-xs font-medium bg-white/15 text-white rounded-full whitespace-nowrap">
                一手爆料
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              黑料在线
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-body font-normal text-white/80 mt-2">
                全网黑料视频一站式观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-white/70 font-body mb-3 max-w-xl mx-auto lg:mx-0">
              每日更新最新黑料大瓜，直接点播无需跳转
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              黑料在线汇聚全网最新最全的黑料视频资源，涵盖网红爆料、明星八卦、社会热点等多元内容。
              平台持续追踪热门事件，每日更新海量正片，支持黑料在线观看与在线播放，无需注册即可免费观看。
              无论是最新大瓜还是经典回顾，黑料视频在线免费观看尽在指尖。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">200+</div>
                <div className="text-xs text-white/50 mt-1 whitespace-nowrap">每日更新条数</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">全网红人</div>
                <div className="text-xs text-white/50 mt-1 whitespace-nowrap">内容覆盖范围</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">免注册</div>
                <div className="text-xs text-white/50 mt-1 whitespace-nowrap">高清无广告观看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                立即观看
              </a>
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-full border border-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20entertainment%20scene%20with%20warm%20spotlight%20and%20dark%20background%2C%20abstract%20visual%20composition%20representing%20breaking%20news%20and%20entertainment%20media%2C%20red%20and%20amber%20color%20accents%20on%20dark%20backdrop%2C%20sophisticated%20modern%20visual%20design%20with%20glowing%20elements%2C%20no%20text&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="黑料在线主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}